import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Lock, X } from 'lucide-react';
interface ViewToggleProps {
  activeView: 'consumer' | 'admin';
}
export function ViewToggle({
  activeView
}: ViewToggleProps) {
  const navigate = useNavigate();
  const [showPinModal, setShowPinModal] = useState(false);
  const [pin, setPin] = useState('');
  const [error, setError] = useState(false);
  const handleToggle = (view: 'consumer' | 'admin') => {
    if (view === activeView) return;
    if (view === 'admin') {
      setShowPinModal(true);
    } else {
      navigate('/portal');
    }
  };
  const handlePinSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (pin.length === 4) {
      setShowPinModal(false);
      setPin('');
      setError(false);
      navigate('/portal/admin');
    } else {
      setError(true);
    }
  };
  return <>
      <div className="flex bg-gray-100 p-1 rounded-full border border-gray-200" data-id="element-873">
        <button onClick={() => handleToggle('consumer')} className={`px-4 py-1.5 text-xs font-bold rounded-full transition-colors ${activeView === 'consumer' ? 'bg-white text-brand-navy shadow-sm' : 'text-brand-muted hover:text-brand-dark'}`} data-id="element-874">
          Consumer View
        </button>
        <button onClick={() => handleToggle('admin')} className={`px-4 py-1.5 text-xs font-bold rounded-full transition-colors flex items-center gap-1.5 ${activeView === 'admin' ? 'bg-brand-navy text-white shadow-sm' : 'text-brand-muted hover:text-brand-dark'}`} data-id="element-875">
          {activeView === 'consumer' && <Lock size={12} data-id="element-876" />}
          Admin View
        </button>
      </div>

      <AnimatePresence data-id="element-877">
        {showPinModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-878">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="absolute inset-0 bg-brand-navy/40 backdrop-blur-sm" onClick={() => setShowPinModal(false)} data-id="element-879" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} className="relative bg-white rounded-2xl shadow-xl border border-gray-200 w-full max-w-sm overflow-hidden" data-id="element-880">
              <div className="px-6 py-5 border-b border-gray-100 flex items-center justify-between" data-id="element-881">
                <h3 className="font-bold text-brand-navy flex items-center gap-2" data-id="element-882">
                  <Lock size={16} data-id="element-883" />
                  Admin Access
                </h3>
                <button onClick={() => setShowPinModal(false)} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-884">
                  <X size={20} data-id="element-885" />
                </button>
              </div>
              <form onSubmit={handlePinSubmit} className="p-6" data-id="element-886">
                <p className="text-sm text-brand-muted mb-4" data-id="element-887">
                  Enter your 4-digit staff PIN to access the admin console.
                </p>
                <div className="mb-6" data-id="element-888">
                  <input type="password" inputMode="numeric" maxLength={4} autoFocus value={pin} onChange={e => {
                setPin(e.target.value.replace(/\D/g, ''));
                setError(false);
              }} className={`w-full text-center text-3xl tracking-[0.5em] font-mono py-3 border-2 rounded-lg focus:outline-none transition-colors ${error ? 'border-brand-red text-brand-red focus:border-brand-red' : 'border-gray-200 text-brand-dark focus:border-brand-navy'}`} placeholder="••••" data-id="element-889" />
                  {error && <p className="text-xs text-brand-red mt-2 text-center" data-id="element-890">
                      Please enter a 4-digit PIN.
                    </p>}
                  <p className="text-xs text-gray-400 mt-2 text-center" data-id="element-891">
                    Hint: Any 4 digits will work for this prototype.
                  </p>
                </div>
                <button type="submit" disabled={pin.length !== 4} className="w-full bg-brand-navy hover:bg-blue-900 disabled:bg-gray-300 text-white py-3 rounded-lg font-bold transition-colors" data-id="element-892">
                  Enter
                </button>
              </form>
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}